import { get } from 'api/request';
import urls from 'configs/urls';

export const getDropdowns = ({ headers }) =>
  get(headers, false, urls.commonUrls.getDropdowns, null);
